
<template>
  <div class="fr-view" ref="froala">
    <slot></slot>
  </div>
</template>

<script>
import config from "../../../config.json";
export default {
    props: ['tag', 'value', 'config', 'onManualControllerReady', 'tags'],

    watch: {
      value: function () {
        this.model = this.value;
        this.updateValue();
      }
    },

    created: function () {
      this.$el = this.$refs['froala'];
      this.model = this.value;
    },

    // After first time render.
    mounted: function() {
      if (this.SPECIAL_TAGS.indexOf(this.currentTag) != -1) {

        this.hasSpecialTag = true;
      }

      if (this.onManualControllerReady) {
        this.generateManualController();
      } else {
        this.createEditor();
      }
    },

    beforeDestroy: function() {
      console.log("Before destroy");
      this.destroyEditor();
    },

    data: function () {

      return {

        

        initEvents: [],

        // Tag on which the editor is initialized.
        currentTag: 'div',

        // Editor element.
        _editor: null,

        // Current config.
        currentConfig: null,

        // Editor options config
        defaultConfig: {
          key: config.froalaKey,
            imageDefaultWidth: 0,
            toolbarSticky: true,
            toggleModal: this.toggleModal,
            enableDropcap: this.enableDropcap,
            toolbarButtons: 	{
              'moreText': {
                'buttons': ['bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', 'fontFamily', 'fontSize', 'textColor', 'backgroundColor', 'enableDropcap', 'inlineClass', 'inlineStyle', 'clearFormatting']
              },
              'moreParagraph': {
                'buttons': ['alignLeft', 'alignCenter', 'formatOLSimple', 'alignRight', 'alignJustify', 'formatOL', 'formatUL', 'paragraphFormat', 'paragraphStyle', 'lineHeight', 'outdent', 'indent', 'quote']
              },
              'moreRich': {
                'buttons': ['insertLink', 'insertImage', 'imageLibrary', 'tweet','instagram', 'jwplayer','insertVideo','insertTable', 'emoticons',  'specialCharacters', 'embedly', 'insertFile', 'insertHR'],
                'buttonsVisible': 5
              },
              'moreMisc': {
                'buttons': ['undo', 'redo', 'fullscreen', 'print', 'getPDF', 'spellChecker', 'selectAll', 'html', 'help'],
                'align': 'right',
                'buttonsVisible': 2
              }
            },
            inlineClasses: {
              'fr-class-code': 'Code',
              'pull-quote': 'MM Quote',
              'fr-class-highlighted': 'Highlighted',
              'fr-class-transparency': 'Transparent'
            },
            events: {
              'image.beforeUpload': (images) => {
                if (images.length) {
                    this.storage.ref()
                      .child("cms_images").child((Date.now() / 1000) + "_" + images[0].name)
                      .put(images[0])
                      .then(async (snapshot) => {
                      
                      var url = await snapshot.ref.getDownloadURL();
                    // this.froalaEditor.image.insert(url, null, null, editor.image.get());
                      this._editor.image.insert(url, false, null, null, {link: "#" });
                    });

                }

                this._editor.popups.hideAll();

                // Stop default upload chain.
                return false;
              }
            },
          immediateVueModelUpdate: false,
          vueIgnoreAttrs: null
        },

        editorInitialized: false,

        SPECIAL_TAGS: ['img', 'button', 'input', 'a'],
        INNER_HTML_ATTR: 'innerHTML',
        hasSpecialTag: false,

        model: null,
        oldModel: null
      };
    },
    methods: {
      enableDropcap: function() {
        this.$emit("toggle-dropcap");
      },

      toggleModal: function() {
        console.log("toggling modal")
        this.$emit("toggle-images-modal", {
          callback: (image) => {
            console.log(image.mobile);
            this._editor.html.insert(`<img src="${image.mobile}" />`);
          },
          type: 'article'
        });
      },

      updateValue: function() {
        if (JSON.stringify(this.oldModel) == JSON.stringify(this.model)) {
          return;
        }

        this.setContent();
      },

      createEditor: function() {
        if (this.editorInitialized) {
          return;
        }

        this.currentConfig = this.config || this.defaultConfig;
        if(!this.currentConfig.key) this.currentConfig.key = config.froalaKey;
        this.setContent(true);

        // Bind editor events.
        this.registerEvents();
        this.initListeners();

        this._editor = new FroalaEditor(this.$el, this.currentConfig)

        this.editorInitialized = true;

      },

      setContent: function (firstTime) {

        if (!this.editorInitialized && !firstTime) {
          return;
        }

        if (this.model || this.model == '') {

          this.oldModel = this.model;

          if (this.hasSpecialTag) {
            this.setSpecialTagContent();
          } else {
            this.setNormalTagContent(firstTime);
          }
        }
      },

      setNormalTagContent: function(firstTime) {

        var self = this;

        function htmlSet() {

          self._editor.html.set(self.model || '');

          //This will reset the undo stack everytime the model changes externally. Can we fix this?

          self._editor.undo.saveStep();
          self._editor.undo.reset();

        }

        if (firstTime) {
          this.registerEvent('initialized', function () {
            htmlSet();
          });
        } else {
          htmlSet();
        }

      },

      setSpecialTagContent: function() {

        var tags = this.model;

        // add tags on element
        if (tags) {

          for (var attr in tags) {
            if (tags.hasOwnProperty(attr) && attr != this.INNER_HTML_ATTR) {
              this.$el.setAttribute(attr, tags[attr]);
            }
          }

          if (tags.hasOwnProperty(this.INNER_HTML_ATTR)) {
            this.$el.innerHTML = tags[this.INNER_HTML_ATTR];
          }
        }
      },

      destroyEditor: function() {
        console.log("Destroying!");
        if (this._editor) {
          if(this._editor.events && this._editor.events.off) {
            this._editor.events.off('contentChanged');
            this._editor.events.off('keyup');
          }
          // this._editor.destroy();
          // this.editorInitialized = false;
          // this._editor = null;
        }
      },

      getEditor: function() {
        return this._editor;
      },

      generateManualController: function() {
        var controls = {
          initialize: this.createEditor,
          destroy: this.destroyEditor,
          getEditor: this.getEditor,
        };

        this.onManualControllerReady(controls);
      },

      updateModel: function () {

        var modelContent = '';

        if (this.hasSpecialTag) {

          var attributeNodes = this.$el[0].attributes;
          var attrs = {};

          for (var i = 0; i < attributeNodes.length; i++ ) {

            var attrName = attributeNodes[i].name;
            if (this.currentConfig.vueIgnoreAttrs && this.currentConfig.vueIgnoreAttrs.indexOf(attrName) != -1) {
              continue;
            }
            attrs[attrName] = attributeNodes[i].value;
          }

          if (this.$el[0].innerHTML) {
            attrs[this.INNER_HTML_ATTR] = this.$el[0].innerHTML;
          }

          modelContent = attrs;
        } else {

          var returnedHtml = this._editor.html.get();
          if (typeof returnedHtml === 'string') {
            modelContent = returnedHtml;
          }
        }

        this.oldModel = modelContent;


        this.$emit('input', modelContent);
      },

      initListeners: function() {
        var self = this;
        this.registerEvent('destroy', function () {
          console.log("froala destroy");
        });
        this.registerEvent('initialized', function () {
          if (self._editor.events) {
            // bind contentChange and keyup event to froalaModel
            self._editor.events.on('contentChanged', function () {
              self.updateModel();
            });

            if (self.currentConfig.immediateVueModelUpdate) {
              self._editor.events.on('keyup', function () {
                self.updateModel();
              });
            }
          }
        })
      },

      // register event on editor element
      registerEvent: function (eventName, callback) {

        if (!eventName || !callback) {
          return;
        }

        // Initialized event.
        if (eventName == 'initialized') {

          this.initEvents.push(callback);
        }
        else {
          if (!this.currentConfig.events) {
            this.currentConfig.events = {};
          }

          this.currentConfig.events[eventName] = callback;
        }

      },

      registerEvents: function () {
        // Handle initialized on its own.
        this.registerInitialized();

        // Get current events.
        var events = this.currentConfig.events;

        if (!events) {
          return;
        }

        for (var event in events) {
          if (events.hasOwnProperty(event) && event != 'initialized') {
            this.registerEvent(event, events[event]);
          }
        }
      },

      registerInitialized: function () {
        // Bind initialized.
        if(!this.currentConfig.events) {
          this.currentConfig.events = {};
        }

        // Set original initialized event.
        if (this.currentConfig.events.initialized) {
          this.registerEvent('initialized', this.currentConfig.events.initialized);
        }

        // Bind initialized event.
        this.currentConfig.events.initialized = () => {
          for (var i = 0; i < this.initEvents.length; i++) {
            this.initEvents[i].call(this._editor);
          }
        }
      }
    }
  };
</script>

<style>
.fr-sticky-on {
    position: sticky !important;
    z-index: 100000000000 !important;
}
.fr-view.fr-basic {
  width: 840px;
  margin:10px auto;
}
.fr-view.fr-basic .fr-toolbar {
  border-radius: 0;
}

.jwplayer-img {
  height: auto;
  width: 200px;
}

.jw-results {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.jw-result {
  flex: 1 0 50%;
  padding: 5px;
  cursor: pointer;
}

.jw-result:hover {
  background: rgba(0,152,247,0.3);
  border-radius: 5px;
  border: solid 1px #0098f7;
}

</style>


// WEBPACK FOOTER //
// Froala.vue?152fbd40